import { Modal } from '@cfs-fixings/shared'
import { DesignDetailResource, DesignResource } from '@/api/serverApi'
import ReassignDesignForm from '@/components/forms/designs/ReassignDesignForm'

const textSpec = {
  title: 'Move to Project',
}

type PropTypes = {
  design: DesignResource | DesignDetailResource
  isOpen: boolean
  onSuccess?: () => void
  onClose: () => void
}

const ReassignDesignModal = ({ design, isOpen, onSuccess, onClose }: PropTypes) => {
  return (
    <Modal
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      title={textSpec.title}
      content={
        <ReassignDesignForm
          design={design}
          onClose={onClose}
          onCompleted={() => onSuccess?.()}
        />
      }
    />
  )
}

export default ReassignDesignModal
